// Impressão direta — SEMPRE pelo Smart Flow Print Agent (PC do caixa, http://localhost:9123).
// Nunca abre o diálogo do navegador: sem agente → mensagem de erro.
// Exceção: modo "Rede (IP/porta)" escolhido explicitamente em Configurações → ESC/POS via servidor.
import axios from 'axios';
import { toast } from 'sonner';
import { probeAgent, printViaAgent, htmlToReceiptText, setReceiptColumns, inlineQrCodes } from './printAgent';
import { loadCompanySettings } from '../hooks/useCompanySettings';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AGENT_OFFLINE_MSG = 'Print Agent não encontrado neste PC. Abra o Smart Flow Print Agent (ou instale em Configurações → Impressora) e tente de novo.';

const fail = (msg) => {
  toast.error('Impressão não realizada', { description: msg, duration: 8000 });
  return { ok: false, error: msg };
};

// Impressora térmica de REDE (ESC/POS via servidor → IP:porta, padrão 9100)
export const printViaNetwork = async (text, cfg = {}) => {
  const { data } = await axios.post(`${API}/print/escpos`, { text, cut: true, ip: cfg.ip, port: cfg.port, open_drawer: !!cfg.openDrawer, logo: true }, { withCredentials: true, timeout: 12000 });
  return data;
};

const loadCfg = async () => {
  try { return (await loadCompanySettings()) || {}; } catch (_e) { return {}; }
};

// Abre só a gaveta (venda em dinheiro sem imprimir cupom). Respeita printer_open_drawer nas configurações.
export const openCashDrawer = async () => {
  const cfg = await loadCfg();
  if (!cfg.printer_open_drawer) return false;
  try {
    if (cfg.printer_mode === 'network' && cfg.printer_ip) {
      await printViaNetwork('', { ip: cfg.printer_ip, port: cfg.printer_port || 9100, openDrawer: true });
      return true;
    }
    if (await probeAgent()) {
      await printViaAgent('', { drawer: true, cut: false });
      return true;
    }
    fail(AGENT_OFFLINE_MSG);
  } catch (e) {
    fail(`Falha ao abrir a gaveta: ${e?.response?.data?.detail || e?.message}`);
  }
  return false;
};

// Converte o HTML do cupom/relatório em texto de 48/32 colunas e envia RAW ao agente.
export const printHtmlSilently = async (html, { openDrawer = false } = {}) => {
  const cfg = await loadCfg();
  setReceiptColumns(Number(cfg.printer_columns) || 48);
  const text = htmlToReceiptText(html);
  const drawer = !!openDrawer && !!cfg.printer_open_drawer;

  if (cfg.printer_mode === 'network' && cfg.printer_ip) {
    try {
      await printViaNetwork(text, { ip: cfg.printer_ip, port: cfg.printer_port || 9100, openDrawer: drawer });
      return { ok: true, via: 'network' };
    } catch (e) {
      return fail(`Impressora de rede ${cfg.printer_ip}:${cfg.printer_port || 9100} não respondeu (${e?.response?.data?.detail || e?.message}).`);
    }
  }

  if (!(await probeAgent())) return fail(AGENT_OFFLINE_MSG);
  try {
    await printViaAgent(inlineQrCodes(text), { drawer });
    return { ok: true, via: 'agent' };
  } catch (e) {
    const offline = e?.name === 'AbortError' || e instanceof TypeError;
    return fail(offline ? AGENT_OFFLINE_MSG : `O Print Agent recusou a impressão: ${e.message}`);
  }
};
